var _path, _path2, _path3, _path4;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDashboard = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66602 2.85999C1.66602 2.36885 2.03911 1.9707 2.49935 1.9707H8.33268C8.79292 1.9707 9.16602 2.36885 9.16602 2.85999V9.08502C9.16602 9.57616 8.79292 9.97431 8.33268 9.97431H2.49935C2.03911 9.97431 1.66602 9.57616 1.66602 9.08502V2.85999ZM3.33268 3.74928V8.19573H7.49935V3.74928H3.33268Z",
    fill: "#171717"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8327 2.85999C10.8327 2.36885 11.2058 1.9707 11.666 1.9707H17.4993C17.9596 1.9707 18.3327 2.36885 18.3327 2.85999V9.08502C18.3327 9.57616 17.9596 9.97431 17.4993 9.97431H11.666C11.2058 9.97431 10.8327 9.57616 10.8327 9.08502V2.85999ZM12.4993 3.74928V8.19573H16.666V3.74928H12.4993Z",
    fill: "#171717"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8327 12.6422C10.8327 12.151 11.2058 11.7529 11.666 11.7529H17.4993C17.9596 11.7529 18.3327 12.151 18.3327 12.6422V18.8672C18.3327 19.3583 17.9596 19.7565 17.4993 19.7565H11.666C11.2058 19.7565 10.8327 19.3583 10.8327 18.8672V12.6422ZM12.4993 13.5315V17.9779H16.666V13.5315H12.4993Z",
    fill: "#171717"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66602 12.6422C1.66602 12.151 2.03911 11.7529 2.49935 11.7529H8.33268C8.79292 11.7529 9.16602 12.151 9.16602 12.6422V18.8672C9.16602 19.3583 8.79292 19.7565 8.33268 19.7565H2.49935C2.03911 19.7565 1.66602 19.3583 1.66602 18.8672V12.6422ZM3.33268 13.5315V17.9779H7.49935V13.5315H3.33268Z",
    fill: "#171717"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDashboard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dashboard.54a51d96.svg";
export { ForwardRef as ReactComponent };